<mat-dialog-content>
  <mat-card class="date-container" (click)="changeShowCalendarValue()">
    @if (data&&data.title) {
      <mat-card-subtitle>
        {{ data.title }}
      </mat-card-subtitle>
    }
    {{ startDate|customDate:'mediumDate':'noYear'|async }}
    @if (endDate) {
      - {{ endDate|customDate:'mediumDate':'noYear'|async }}
      ,  {{ endDate|customDate:'custom':'yyyy'|async }}
    }
  </mat-card>
  @if (showCalendar&&!disabled) {
    <mat-calendar
      [dateClass]="dateClass"
      (selectedChange)="selectDate($event)"
      [maxDate]="maxDate"
      [startAt]="this.dateForm.get('start')?.value!"
      >
    </mat-calendar>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="null" color="accent">
    <mat-icon>clear</mat-icon>
  </button>
  <button mat-flat-button (click)="closeDialog()" color="primary">
    <mat-icon>check</mat-icon>
  </button>
  @if (data.buttons) {
    @for (button of data.buttons; track button) {
      <button mat-flat-button (click)="closeDialogButtons(button.action)" [color]="button.color">
        @if (button.icon) {
          <mat-icon>{{ button.icon }}</mat-icon>
        } @else {
          {{ button.text }}
        }
      </button>
    }
  }
</mat-dialog-actions>